
//重要なお知らせボタンを閉じる
$(document).on("click", ".l-floatingNews__close", function() {
  $(this).closest('.l-floatingNews__item').addClass('is-close');
});

